import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

interface Styles {
  tooltip: Object;
  arrow: Object;
}
interface ToolTipProps {
  title: React.ReactElement| string;
  children: React.ReactElement;
  className?: string;
  placement? : "top" | "bottom-end" | "bottom-start" | "bottom" | "left-end" | "left-start" | "left" | "right-end" | "right-start" | "right" | "top-end" | "top-start" | undefined;
  styles?: Styles;
  [key: string]: any;
}

const HtmlTooltip = styled(({ className, title, children, placement, styles, ...props }: ToolTipProps) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Tooltip children={children} title={title} {...props} classes={{ popper: className }} arrow placement={placement || "top"} />
  ))(({ styles }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'white',
      color: '#050552',
      maxWidth: 220,
      fontFamily: 'Lato',
      fontSize: '12px',
      lineHeight: 1.5,
      letterSpacing: 'normal',
      padding: '8px 12px',
      margin: '0px',
      boxShadow: '0 4px 15px 0 rgba(5, 5, 82, 0.1)',
      border: 'solid 0.5px #ebeef1',
      ...(styles && styles.tooltip ? { ...styles.tooltip } : {})
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: 'white',
      ...(styles && styles.arrow ? { ...styles.arrow } : {})
    },
  }));
  
export default HtmlTooltip;